import { IconComponentProps } from '@typings';

export const GridViewTemplate = (props: IconComponentProps) => {
  return (
    <svg viewBox="0 0 112 80" fill="none" {...props}>
      <g clipPath="url(#prefix__clip0_10_4261)">
        <path d="M0 0h112v80H0V0z" fill="#fff" />
        <path d="M.5.5h111v79H.5V.5z" fill="#fff" stroke="#E5E5E5" />
        <path d="M7.149 31.257h6.716v6.776H7.149v-6.776z" fill="#CCC" />
        <path d="M15.814 31.257h9.532v4.153h-9.532v-4.153zM7.149 40.437h24.046v7.104H7.15v-7.104z" fill="#E5E5E5" />
        <path d="M7.149 55.3h6.716v6.777H7.149V55.3z" fill="#CCC" />
        <path d="M15.814 55.3h9.532v4.154h-9.532V55.3zM7.149 64.48h24.046v7.105H7.15V64.48z" fill="#E5E5E5" />
        <path d="M42.027 7.213h6.716v6.776h-6.716V7.213z" fill="#CCC" />
        <path d="M50.692 7.213h9.532v4.153h-9.532V7.213zM42.027 16.393h24.046v7.104H42.027v-7.104z" fill="#E5E5E5" />
        <path d="M42.027 31.257h6.716v6.776h-6.716v-6.776z" fill="#CCC" />
        <path d="M50.692 31.257h9.532v4.153h-9.532v-4.153zM42.027 40.437h24.046v7.104H42.027v-7.104z" fill="#E5E5E5" />
        <path d="M42.027 55.3h6.716v6.777h-6.716V55.3z" fill="#CCC" />
        <path d="M50.692 55.3h9.532v4.154h-9.532V55.3zM42.027 64.48h24.046v7.105H42.027V64.48z" fill="#E5E5E5" />
        <path d="M76.905 7.213h6.716v6.776h-6.716V7.213z" fill="#CCC" />
        <path d="M85.57 7.213h9.533v4.153H85.57V7.213zM76.905 16.393h24.047v7.104H76.905v-7.104z" fill="#E5E5E5" />
        <path d="M76.905 31.257h6.716v6.776h-6.716v-6.776z" fill="#CCC" />
        <path d="M85.57 31.257h9.533v4.153H85.57v-4.153zM76.905 40.437h24.047v7.104H76.905v-7.104z" fill="#E5E5E5" />
        <path d="M76.905 55.3h6.716v6.777h-6.716V55.3z" fill="#CCC" />
        <path d="M85.57 55.3h9.533v4.154H85.57V55.3zM76.905 64.48h24.047v7.105H76.905V64.48z" fill="#E5E5E5" />
        <path d="M7.149 7.213h6.716v6.776H7.149V7.213z" fill="#CCC" />
        <path d="M15.814 7.213h9.532v4.153h-9.532V7.213zM7.149 16.393h24.046v7.104H7.15v-7.104z" fill="#E5E5E5" />
      </g>
      <defs>
        <clipPath id="prefix__clip0_10_4261">
          <path fill="#fff" d="M0 0h112v80H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};
